import React from 'react';
import style from '@styles/general/general.module.css';
const Heading = ({
  headline,
  isTop
}) => {
  return <h1 className={isTop ? style.heading : `${style.heading} ${style.notTop}`} data-sentry-component="Heading" data-sentry-source-file="Heading.jsx">
        {headline}
    </h1>;
};
export default Heading;